import React from "react";
import "../App.css";
import "./AfterHours.css"; // Import the new CSS file
import Modal from "@mui/material/Modal";
import { Link } from "react-router-dom";
import Menu from "./Menu";
import saladsImage from "../images/after-hours-focaccia.jpg";
import quicheImage from "../images/after hours schnitz.jpg";
import luxFishImage from "../images/after hours outside close.jpg";
import ramenImage from "../images/after hours wine bottles.jpg";

function AfterHours() {
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [afterHoursMenuPdfUrl, setAfterHoursMenuPdfUrl] = React.useState("");

  React.useEffect(() => {
    let isMounted = true;

    fetch("/resumeData.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load menu configuration");
        }

        return response.json();
      })
      .then((resumeData) => {
        if (isMounted) {
          setAfterHoursMenuPdfUrl(resumeData?.main?.afterHoursMenuPdfUrl || "");
        }
      })
      .catch(() => {
        if (isMounted) {
          setAfterHoursMenuPdfUrl("");
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const modalStyle = {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    width: "90%",
    maxHeight: "90%",
    overflow: "auto",
  };

  const handleMenuClick = () => {
    if (afterHoursMenuPdfUrl) {
      window.open(afterHoursMenuPdfUrl, "_blank", "noopener,noreferrer");
      return;
    }

    setModalIsOpen(true);
  };

  return (
    <div className="after-hours-page">
      <Modal
        open={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        aria-labelledby="after-hours-menu-title"
        aria-describedby="after-hours-menu-description"
      >
        <div style={modalStyle}>
          <div id="after-hours-menu-description">
            <Menu closeModal={() => setModalIsOpen(false)} />
          </div>
        </div>
      </Modal>

      <header
        className="after-hours-hero"
        style={{ backgroundImage: `url(${saladsImage})` }}
      >
        <nav className="after-hours-nav" aria-label="After Hours navigation">
          <Link className="after-hours-nav-link" to="/">
            Home
          </Link>
          <a
            className="after-hours-nav-link"
            href="https://www.opentable.com.au/r/after-hours-by-cut-lunch-deli-reservations-randwick?restref=298124&lang=en-AU&ot_source=Restaurant%20website"
            target="_blank"
            rel="noreferrer"
          >
            Bookings
          </a>
          <button
            type="button"
            className="after-hours-nav-link after-hours-nav-button"
            onClick={handleMenuClick}
          >
            Menu
          </button>
        </nav>
        <h1 className="after-hours-title">AFTER HOURS</h1>
      </header>
      <section className="after-hours-section">
        <p className="after-hours-subtitle">Minimal Intervention Wines. Local Tinnies. Share Plates.</p>
        <div className="after-hours-images">
          <div className="image-container">
            <img src={quicheImage} alt="Quiche" className="after-hours-image" />
          </div>
          <div className="image-container">
            <img src={luxFishImage} alt="Lux fish" className="after-hours-image" />
          </div>
          <div className="image-container">
            <img src={ramenImage} alt="Ramen" className="after-hours-image" />
          </div>
        </div>
        <div className="after-hours-hours">
          <p>HOURS</p>
          <p>THURS 5PM - 8:30PM</p>
          <p>FRI-SUN 3:00PM - LATE</p>
        </div>
      </section>
    </div>
  );
}

export default AfterHours;